import { Skeleton } from "@/components/ui/skeleton";

export const PropertyCardSkeleton = () => {
    return (
        <div className="rounded-3xl overflow-hidden border border-border bg-card shadow-sm h-full flex flex-col">
            {/* Image Skeleton */}
            <Skeleton className="w-full aspect-[4/3] rounded-none custom-skeleton-pulse" />

            <div className="p-6 md:p-7 space-y-4 flex-1 flex flex-col">
                {/* Location */}
                <div className="flex items-center gap-2">
                    <Skeleton className="h-5 w-5 rounded-full" />
                    <Skeleton className="h-4 w-32" />
                </div>

                {/* Title */}
                <div className="space-y-2">
                    <Skeleton className="h-7 w-full" />
                    <Skeleton className="h-7 w-2/3" />
                </div>

                {/* Price */}
                <Skeleton className="h-8 w-40" />

                {/* Features */}
                <div className="flex items-center justify-between pt-5 border-t border-border/50 mt-auto">
                    <div className="flex items-center gap-2">
                        <Skeleton className="h-10 w-10 rounded-xl" />
                        <div className="space-y-1">
                            <Skeleton className="h-4 w-8" />
                            <Skeleton className="h-3 w-6" />
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <Skeleton className="h-10 w-10 rounded-xl" />
                        <div className="space-y-1">
                            <Skeleton className="h-4 w-8" />
                            <Skeleton className="h-3 w-6" />
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <Skeleton className="h-10 w-10 rounded-xl" />
                        <div className="space-y-1">
                            <Skeleton className="h-4 w-8" />
                            <Skeleton className="h-3 w-6" />
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="pt-5 border-t border-border/50 flex gap-2">
                    <Skeleton className="h-9 flex-1" />
                    <Skeleton className="h-9 flex-1" />
                    <Skeleton className="h-9 flex-1" />
                </div>
            </div>
        </div>
    )
}

export const LocationCardSkeleton = () => {
    return (
        <div className="relative overflow-hidden rounded-lg shadow-md h-48 bg-muted">
            <Skeleton className="h-full w-full" />
            <div className="absolute inset-0 flex flex-col justify-end p-6 space-y-2 z-10">
                <div className="flex items-center gap-2">
                    <Skeleton className="h-5 w-5 rounded-full bg-white/20" />
                    <Skeleton className="h-6 w-32 bg-white/20" />
                </div>
                <Skeleton className="h-4 w-24 bg-white/20" />
            </div>
        </div>
    )
}

export const BlogCardSkeleton = () => {
    return (
        <div className="overflow-hidden rounded-lg shadow-md h-full flex flex-col bg-card">
            <Skeleton className="h-48 w-full rounded-none" />
            <div className="p-6 flex-1 flex flex-col space-y-4">
                <Skeleton className="h-4 w-24" />
                <div className="space-y-2">
                    <Skeleton className="h-6 w-full" />
                    <Skeleton className="h-6 w-2/3" />
                </div>
                <div className="space-y-2">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-2/3" />
                </div>
                <Skeleton className="h-4 w-20 mt-auto" />
            </div>
        </div>
    )
}
